// System
import { Stack, Typography, Box } from '@mui/material';

// Redux
import { useRubberDuckRoundDrawer } from '@Modal/hooks/rounds/useRubberDuckRoundDrawer';

export const SetupRubberDuckRoundHeader: React.FC = () => {
  const { selectedRoundData } = useRubberDuckRoundDrawer();
  return (
    <Stack>
      <Box>
        <Typography variant="h6">
          {selectedRoundData?._id ? selectedRoundData?._id : 'No Result'}
        </Typography>
      </Box>
    </Stack>
  );
};
